import { defaultTo, map, path, pipe } from 'ramda';
import sumBy from 'lodash/fp/sumBy';
import { fullName } from '../../../common/helpers/users';

export const getIsFetching = path(['reports', 'dashboard', 'isFetching']);

const assignBarber = getBarberById => (obj = {}) => {
  if (!obj.barberId) return obj;
  return {
    ...obj,
    barber: obj.barberId.map(id => getBarberById(id, true)),
  };
};

export const getServiceSales = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'serviceSales']),
  assignBarber(getBarberById),
)(state);

export const getProductSales = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'productSales']),
  assignBarber(getBarberById),
)(state);

export const getLeaderboardProductivity = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'productivity']),
  assignBarber(getBarberById),
)(state);

export const getAverageSale = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'averageTransactionAmount']),
  assignBarber(getBarberById),
)(state);

export const getNewCustomers = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'newCustomers']),
  assignBarber(getBarberById),
)(state);

export const getPercentageThatIncludeAtLeastOneProduct = (state, getBarberById) => pipe(
  path(['reports', 'dashboard', 'response', 'leaderBoard', 'percentageThatIncludeAtLeastOneProduct']),
  assignBarber(getBarberById),
)(state);

export const getShopProductivity = path(['reports', 'dashboard', 'response', 'shop', 'productivity']);

export const getAverageServicePrice = path(['reports', 'dashboard', 'response', 'shop', 'averageServicePrice']);

export const getServiceSoldCount = path(['reports', 'dashboard', 'response', 'shop', 'serviceSoldCount']);

export const getAverageProductPrice = path(['reports', 'dashboard', 'response', 'shop', 'averageProductPrice']);

export const getProductSoldCount = path(['reports', 'dashboard', 'response', 'shop', 'productSoldCount']);

const mapData = map(item => ({
  id: item.id,
  name: item.name,
  value: item.amount,
}));

const getTopServices = pipe(
  path(['reports', 'dashboard', 'response', 'topLists', 'topServices']),
  defaultTo([]),
);

export const getTopServicesTotal = pipe(
  getTopServices,
  sumBy('amount')
);

export const getTopServicesData = pipe(
  getTopServices,
  mapData,
);

const getTopProducts = pipe(
  path(['reports', 'dashboard', 'response', 'topLists', 'topProducts']),
  defaultTo([]),
);

export const getTopProductsTotal = pipe(
  getTopProducts,
  sumBy('amount')
);

export const getTopProductsData = pipe(
  getTopProducts,
  mapData,
);

const getTopBarbers = pipe(
  path(['reports', 'dashboard', 'response', 'topLists', 'topBarbers']),
  defaultTo([]),
);

export const getTopBarbersTotal = pipe(
  getTopBarbers,
  sumBy('amount')
);

const mapBarber = getBarberById => map(item => ({
  id: item.id,
  value: item.amount,
  name: item.id && fullName(getBarberById(item.id, true)),
}));

export const getTopBarbersData = (state, getBarberById) => pipe(
  getTopBarbers,
  mapBarber(getBarberById),
)(state);
